<template>
  <body class="main-body disp-scroll">
    <template v-if="isLoading">
      <!-- ローディング画面 -->
      <div class="loading">
        <Loading/>
      </div>
    </template>
    <template v-else>
      <!-- ヘッダー部 -->
      <div class="company-header">
        <div class="left-box">
          <p class="-company">{{recordingInterview.company_name}}</p>
          <p class="-name">お名前: {{name ? name : 'no name'}} {{email ? '（' + email + '）' : ''}}</p>
        </div>
        <div class="right-box">
          <h2 style="font-weight: 600;">
            <span class="mdi mdi-camcorder-box -right-8px"></span>録画面接
          </h2>
        </div>
      </div>
      <!-- 時間外 -->
      <div class="outtime" v-if="isOutTime">
        <img src="@/assets/template/wait.png"/>
        <p>
          この度は{{recordingInterview.company_name}}の面接にお越しいただきまして
          誠にありがとうございます。<br>
          大変申し訳ございませんが、現在<b>面接時間外</b>となっております。
          また改めてお越しいただけますと幸いでございます。<br><br>
          ※面接時間帯<b>（{{this.recordingInterview.start_hhmm}} ～ {{this.recordingInterview.end_hhmm}}）</b>
        </p>
      </div>
      <!-- 時間内面接前 -->
      <template v-else>
        <div class="start" v-if="step === 0">
          <p>
            この度は{{recordingInterview.company_name}}の面接にお越しいただきまして
            誠にありがとうございます。<br>
            まず初めにお名前をフルネームで、またEmailアドレスをご記入お願い致します。
          </p>
          <div style="margin-top: 16px;">
            <p><b>お名前</b></p>
            <input placeholder="面接 太郎" class="input is-fullwidth" :change="inputCheck" v-model="name"/>
            <p><b>Eメール</b></p>
            <input placeholder="mensetsu.taro@xxx.co.jp" class="input is-fullwidth" :change="inputCheck" v-model="email"/>
          </div>
          <button
            style="margin-top: 16px;" class="button is-primary"
            @click="interviewedUserDuplicateCheck()"
            :disabled="isNextDisabled"
          >
            <span class="mdi mdi-play -right-8px"></span>
            次へ
          </button>
        </div>
        <div class="start" v-else-if="step === 1">
          <div>
            <p>見て頂く動画、回答頂く動画は全部で<b>{{recordingInterview.recording_content.length}}</b>本になります。</p>
            <p>動画閲覧後、回答ボタンをクリックして下さい。次に「録画を開始」ボタンを押下すると録画が開始されます。</p>
            <p>回答後は「録画を終了」ボタンを 押下してください。</p>
            <p>「回答を終了」ボタンが表示されますので、そちらを押下していただきますと、回答結果を送信いたします。</p>
            <p><span style="color: red">制限時間は<b>{{recordingInterview.total_limit_time}}分</b>です。</span>制限時間をすぎると強制的に終了し、録画データが送信されますので時間内に回答いただきますようよろしくお願いいたします。</p>
            <p style="color: red">途中でブラウザを閉じたり、違うページへ遷移したり、更新したりすると再入室できなくなりますのでご注意ください。</p>
          </div>
          <button class="button is-primary" @click="step=0">
            <span class="mdi mdi-undo -right-8px"></span>
            戻る
          </button>
          <button class="button is-primary" @click="startInterview()">
            <span class="mdi mdi-play -right-8px"></span>
            面接を開始する
          </button>
        </div>
        <div class="video-container" v-else-if="step === 2">
          <div class="video-wrapper">
            <div class="question-title">
              <p style="color: #a22;"><b>({{index + 1}}). {{recordingInterview.recording_content[index].name}}</b></p>
              <p>
                <span class="mdi mdi-timer -right-8px"></span>
                回答制限時間： {{recordingInterview.recording_content[index].answer_time}}秒
              </p>
              <p>
                <span class="mdi mdi-timer -right-8px"></span>
                再再生選択可能時間： {{recordingInterview.recording_content[index].replayable_time}}秒
              </p>
              <p class="tag is-primary" v-if="recordingAnswers[index].answer_recording">
                回答済
              </p>
              <p class="tag is-info" v-else>
                未回答
              </p>
            </div>
            <template v-if="idxAnswer === index">
              <!-- 録画前 -->
              <template v-if="!recordingAnswers[index].answer_recording">
                <span class="desc">カメラをONにすると録画が可能になります。</span><br/>
                <b-switch
                  v-model="isCameraActive"
                  @input="cameraSwitch()"
                  :disabled="isRecording()"
                  v-if="!recordingAnswers[index].answer_recording"
                >
                  カメラ{{isCameraActive ? 'ON' : 'OFF'}}
                </b-switch>
                <b-progress
                  type="is-success"
                  style="margin-bottom: 8px;"
                  :max="recordingInterview.recording_content[index].answer_time" :value="timer" show-value>
                  {{timer}}秒 経過
                </b-progress>
                <div class="recording-wrapper">
                  <video class="recording-back" id="answer" autoplay muted/>
                  <div class="start-button" @click="startRecording()" v-if="!isRecording()">
                    <p>
                      <span class="mdi mdi-play -right-4px"></span>
                      録画を開始
                    </p>
                    <span class="desc">クリックすると録画が即座に開始されます。</span>
                    <span class="desc">ハウリング防止のためマイクをお使いいただくことを推奨いたします。</span>
                  </div>
                </div>
              </template>
              <!-- 撮影直後の回答動画 -->
              <template v-else>
                <RecordingVideoTag
                  mode="answer"
                  :index="index"
                  :video="recordingAnswers[index].answer_recording"
                />
              </template>
            </template>
            <template v-else-if="recordingAnswers[index].replayStep === 1" class="recording-wrapper">
              <div class="start-button">
                <b-progress
                  type="is-success"
                  :max="recordingInterview.recording_content[index].replayable_time" :value="replayTimer" show-value>
                  {{replayTimer}}秒 経過
                </b-progress>
                <p>
                  <span class="mdi mdi-play -right-4px"></span>
                  {{recordingInterview.recording_content[index].replayable_time}}秒以内であれば
                  一度のみ、理由を入力の上再再生できます。再再生しますか？
                </p>
                <div>
                  <button class="button is-primary" style="margin-bottom: 16px;" @click="recordingAnswers[index].replayStep = 2; stopReplayTimer ()">
                    理由を入力して再再生する
                  </button>
              </div>
            </div>
            </template>
            <template v-else-if="recordingAnswers[index].replayStep === 2" class="recording-wrapper">
              <div class="start-button">
                <p>
                  <span class="mdi mdi-play -right-4px"></span>
                  理由を入力して再再生してください。
                </p>
                <div>
                  <textarea
                    style="min-height: 88px;"
                    class="textarea"
                    placeholder="再再生の理由を記載"
                    maxlength="300"
                    v-model="reason_replay"
                  />
                  <button style="margin: 16px 0px;" class="button is-primary" @click="reasonInputCheck()">
                    再再生する
                  </button>
              </div>
            </div>
            </template>
            <template v-else-if ="recordingAnswers[index].answer_recording">
            <!-- 撮影済み回答動画 -->
              <RecordingVideoTag
                mode="answer"
                :index="index"
                :video="recordingAnswers[index].answer_recording"
              />
            </template>
            <!-- 質問動画 -->
            <template v-else>
              <RecordingVideoTag
                mode="question"
                :index="index"
                :replayStep="recordingAnswers[index].replayStep"
                :video="recordingInterview.recording_content[index].question_recording"
                :videoMp4="recordingInterview.recording_content[index].question_recording_mp4"
                @endedVideo="endedVideo"
              />
            </template>
            <div class="button-menu">
              <template
                v-if="
                  !recordingAnswers[index].answer_recording
                  &&
                  idxAnswer === index
                ">
                <button
                  class="button is-primary"
                  @click="stopRecording()"
                  :disabled="!isRecording()">
                  ■ 録画を終了
                </button>
              </template>
              <template v-if="idxAnswer === index">
                <button
                  class="button is-primary"
                  @click="setAnswerIdx(-1)"
                  :disabled="isRecording() || isUploadLoading || this.recordingAnswers[index].answer_recording">
                  質問({{index + 1}})の画面へ
                </button>
              </template>
              <template v-else>
                <button
                  class="button is-primary"
                  @click="setAnswerIdx(index)"
                  :disabled="isRecording() || isUploadLoading || this.recordingAnswers[index].answer_recording">
                  質問({{index + 1}})に回答する
                </button>
              </template>
              <b-dropdown class="speedup-list" aria-role="list" v-if="recordingInterview.recording_content[index].question_recording && !isRecording()">
                <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                  <span>再生速度 × {{speedRate}}</span>
                  <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                </button>
                <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.0)">× 1.0</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.2)">× 1.2</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.5)">× 1.5</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.7)">× 1.7</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(2.0)">× 2.0</b-dropdown-item>
              </b-dropdown>
            </div>
            <hr>
            <button
              class="button prev-button"
              @click="changeIndex(-1)"
              :disabled="isMinIndex || isRecording() || isUploadLoading">
              <span class="mdi mdi-chevron-left"></span>
              前の質問へ
            </button>
            <button
              class="button next-button"
              @click="createRecordingAnswerConfirm()"
              :disabled="!isMaxIndex || !isEnd || isRecording() || isUploadLoading">
              <template v-if="!isUploadLoading">
                回答を終了する
              </template>
              <template v-else>
                <span class="mdi mdi-spin mdi-loading -right-8px"></span>アップロード中です
              </template>
            </button>
            <button
              class="button next-button"
              @click="changeIndex(1)"
              :disabled="isMaxIndex || isRecording() || isUploadLoading">
              <span class="mdi mdi-chevron-right"></span>
              次の質問へ
            </button>
            <div class="total-count-icon">
              <div class="count-wrapper">
                <p class="nokorijikan">残り時間</p>
                <p class="count">
                  {{calcSecondsPassed(recordingInterview.total_limit_time, countPassed)}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="outtime" v-else-if="step === 3">
          <img style="border-radius: 8px;" src="@/assets/template/create_flow.png"/>
          <p>
            この度は{{recordingInterview.company_name}}の面接にご参加頂きまして誠にありがとうございました。<br>
            面接は以上で終了になります。このままブラウザを閉じていただけますと幸いでございます。
          </p>
        </div>
        <div
          v-if="isLoadingCreateRecordingAnswer"
          class="loading-wrapper"
        >
          <Loading />
        </div>
      </template>
    </template>
  </body>
</template>

<script>
import VideoRecording    from '@/functions/class/VideoRecording'
import Loading           from '@/components/animations/Loading'
import RecordingVideoTag from '@/components/VideoView/organisms/RecordingVideoTag'
import createUUID        from '@/functions/createUUID'
import {isMailAddress}   from '@/functions/common/checksFunc'
export default {
  components: {
    Loading,
    RecordingVideoTag
  },
  data () {
    return {
      recordingInterview: null,
      isLoading: true,
      video: null,
      name: null,
      email: null,
      step: 0,
      index: 0,
      speedRate: 1.0,
      recordingAnswers: [],
      idxAnswer: -1,
      timer: 0,
      replayTimer: 0,
      timerID: null,
      replayTimerID: null,
      reason_replay:'',
      cntSendRecording: 0,
      isUploadLoading: false,
      isCameraActive: false,
      settingCount: 10,
      countPassed: 0,
      isLoadingCreateRecordingAnswer: false,
      isTimeover: false,
      completeRecordingAnswerInfoId: null,
      totalTimer: null,
      isNextDisabled: true
    }
  },
  created () {
    this.$store.dispatch('directtalk/getRecordingInterviewAny', this.$route.params.id)
      .then((d) => {
        this.recordingInterview = d
        this.recordingInterview.recording_content.forEach((v) => {
          this.recordingAnswers.push({
            answer_name: null,
            answer_email: null,
            answer_uuid: null,
            recording_inteview: this.recordingInterview.id,
            recording_content: v.id,
            answer_recording: null,
            replayTimerFlug: true,
            replayStep: 0
          })
        })
        this.isLoading = false
      })
    this.windowClosePrevent()
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      e.returnValue = '';
    })
  },
  computed: {
    isOutTime () {
      const now = new Date()
      const hh  = now.getHours()
      const mm  = now.getMinutes()
      const reg = new RegExp(":", "g")
      const hhmmStart  = this.recordingInterview.start_hhmm.replace(reg, '').slice(0, -2)
      const hhmmEnd    = this.recordingInterview.end_hhmm.replace(reg, '').slice(0, -2)
      return Number(hhmmStart) >= Number(hh * 100 + mm) || Number(hhmmEnd) <= Number(hh * 100 + mm)
    },
    inputCheck () {
      const strReturn = isMailAddress(this.email, 'Emailアドレス')
      let isReturn = false
      if (strReturn !== '') {
        isReturn = true
      }
      this.isNextDisabled = !this.name || isReturn
    },
    isMaxIndex () {
      return this.index === this.recordingInterview.recording_content.length - 1
    },
    isMinIndex () {
      return this.index === 0
    },
    isEnd () {
      let flg = true
      this.recordingAnswers.forEach((v) => {
        if (!v.answer_recording) flg = false
      })
      return flg
    }
  },
  watch: {
    index () {
      this.speedRate = 1.0
    },
    timer () {
      if (this.recordingInterview.recording_content[this.index].answer_time < this.timer) {
        this.stopRecording()
      }
    },
    replayTimer () {
      if (this.replayTimer === this.recordingInterview.recording_content[this.index].replayable_time) {
        this.changeReplayStep ()
        this.recordingAnswers[this.index].replayStep = 4
      }
    },
    async cntSendRecording () {
      if (this.recordingAnswers.length === this.cntSendRecording) {
        const recordingAnswerInfo = {
          id: this.completeRecordingAnswerInfoId,
          recording_inteview: this.recordingInterview.id,
          is_timeover: this.isTimeover,
          is_interrupted: false,
        }
        try {
          await this.$store.dispatch('directtalk/updateCompleteRecordingAnswerInfo', recordingAnswerInfo)
          await this.$store.dispatch('directtalk/completeRecordingAnswerNotify', {
            name: this.name,
            email: this.email,
            company: this.recordingInterview.company,
            id: this.recordingInterview.id,
            is_timeover: this.isTimeover
          })
          this.isLoadingCreateRecordingAnswer = false
          this.step++
          alert('回答データの送付が完了いたしました。\n面接は以上で終了となりますので、このままブラウザを閉じてください。')
          this.isUploadLoading = true
        } catch(e) {
          console.error(e)
          alert("送信途中にエラーが発生いたしました。通信環境の良い場所で再度ご送信いただきますようよろしくお願いいたします。")
          this.isLoadingCreateRecordingAnswer = false
          this.isUploadLoading = false
        }
      }
    }
  },
  methods: {
    reasonInputCheck () {
      if (this.reason_replay) {
        this.reasonReplay(this.reason_replay);
      } else {
        alert('再再生の理由を入力してください')
      }
    },
    reasonReplay(reason_replay) {
      this.recordingAnswers[this.index].replayStep = 3
      this.recordingAnswers[this.index].reason_replay = reason_replay
      this.reason_replay = ''
    },
    endedVideo () {
      if (this.recordingAnswers[this.index].replayStep === 0) {
        this.recordingAnswers[this.index].replayStep = 1
        this.startReplayTimer()
      }else {
        this.recordingAnswers[this.index].replayStep = 4
      }
    },
    startTimer () {
      this.timerID = setInterval(() => {
        this.timer++
        this.$forceUpdate()
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.timerID)
      this.timerID = null
      this.timer = 0
      this.$forceUpdate()
    },
    startReplayTimer () {
      this.replayTimerID = setInterval(() => {
        this.replayTimer++
        this.$forceUpdate()
      }, 1000)
    },
    stopReplayTimer () {
      clearInterval(this.replayTimerID)
      this.replayTimer = 0
      this.$forceUpdate()
    },
    changeSpeedRate (rate) {
      this.$nextTick(() => {
        let video = document.getElementById('question-' + this.index)
        video.playbackRate = rate
        this.speedRate = rate
      })
    },
    changeIndex (delta) {
      const res = delta + this.index
      const max = this.recordingInterview.recording_content.length - 1
      if (res < 0) {
        this.index = max
      } else if (res > max) {
        this.index = 0
      } else {
        this.index = res
      }
      this.idxAnswer = -1
    },
    cameraSwitch () {
      if (this.isCameraActive) {
        this.createVideoElement()
      } else {
        if(this.video != null) {
          this.video.stopVideo()
          this.video = null
          this.isCameraActive = false
        }
      }
    },
    createVideoElement () {
      if (!this.video) {
        this.video = new VideoRecording (
          document.getElementById('answer'),
          1024,
          720
        )
      }
    },
    startRecording () {
      if (this.timerID) {
        // タイマーが残っていることがあるのでクリア
        this.stopTimer()
      }
      if (!this.isCameraActive) {
        // カメラOFFなら撮影不可
        return
      }
      if (!this.video || !this.video.isStreamActive()) {
        //メディアストリームが非アクティブなら撮影不可
        alert('撮影が開始できません。カメラ・マイクの接続、アクセス許可、ミュートのON/OFFを確認してください。')
        return
      }
      // 撮影開始
      if (this.video) {
        this.video.startRecording()
        this.startTimer()
        setTimeout(() => {
          this.$forceUpdate()
        }, 10)
      }
    },
    stopRecording () {
      this.video.stopRecording()
      setTimeout(() => {
        this.recordingAnswers[this.index]
          .answer_recording = this.video.getRecordingFile()
        this.stopTimer()
        this.video.stopVideo()
        this.video = null
        this.timer = 0
        this.isCameraActive = false
      }, 10)
    },
    changeReplayStep () {
      this.stopReplayTimer()
      this.recordingAnswers[this.index].replayStep = 4
    },
    deleteRecording (idx) {
      let con = window.confirm('録画データを削除しますがよろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      this.recordingAnswers[idx].answer_recording = null
    },
    isRecording () {
      if (this.video) {
        return this.video.getRecordingState() === 'recording'
      } else {
        return false
      }
    },
    setAnswerIdx (idx) {
      if (idx === -1) {
        this.isCameraActive = false
        this.cameraSwitch()
        // カメラを停止しきってから質問画面へ
        this.$nextTick(() => {
          this.idxAnswer = idx
        })
      } else {
        // 回答画面へ
        this.idxAnswer = idx
      }
    },
    createRecordingAnswerConfirm () {
      const con = window.confirm('回答データを送付しますがよろしいでしょうか？\nアップロード中はブラウザを閉じないようお願い致します。')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      this.createRecordingAnswer()
    },
    stopTotalTimer () {
      clearInterval(this.totalTimer)
    },
    async createRecordingAnswer () {
      this.cancelWindowClosePrevent()
      this.stopTotalTimer()
      for (let index = 0; index < this.recordingInterview.recording_content.length; index++) {
        if (this.video !== null) {
          this.video.stopVideo()
          this.video = null
        }
      }
      this.isUploadLoading = true
      const id = createUUID()
      for (const record of this.recordingAnswers) {
        let createData = new FormData()
        createData.append('recording_inteview', record.recording_inteview)
        createData.append('recording_content', record.recording_content)
        createData.append('reason_replay', record.reason_replay)
        createData.append('answer_uuid', id)
        createData.append('answer_name', this.name)
        createData.append('answer_email', this.email)
        if (record.answer_recording) {
          const newFile = new File(
            [record.answer_recording],
            record.recording_content + '-' + id + '-' + this.name,
            { type: 'application/octet-stream' }
          )
          createData.append('answer_recording', newFile)
        } else {
          createData.append('answer_recording', None)
        }
        const seekerId = localStorage.getItem('SID_' + this.$route.params.companyid)
        if (seekerId) createData.append('seeker_id', seekerId)
        this.isLoadingCreateRecordingAnswer = true
        try {
          await this.$store.dispatch('directtalk/createRecordingAnswer', createData)
          this.cntSendRecording++
        } catch(e) {
          console.error(e)
          this.cntSendRecording = 0
          this.isUploadLoading = false
          this.isLoadingCreateRecordingAnswer = false
          alert("送信途中にエラーが発生いたしました。通信環境の良い場所で再度ご送信いただきますようよろしくお願いいたします。")
          return
        }
      }
    },
    countup () {
      this.timeOver()
      this.countPassed++;
    },
    startInterview () {
      this.windowClosePrevent()
      this.step = 2
      this.totalTimer = setInterval(this.countup, 1000);
      const recordingAnswerInfo = {
        recording_inteview: this.recordingInterview.id,
        name: this.name,
        email: this.email,
        is_timeover: false,
        is_interrupted: true,
      }
      this.$store.dispatch('directtalk/createCompleteRecordingAnswerInfo', recordingAnswerInfo)
        .then((d) => {
          this.completeRecordingAnswerInfoId = d.data.id
        })
        .catch((e) => {
          console.error(e)
        })
    },
    calcSecondsPassed (minutes, countPassed) {
      if (minutes * 60 - countPassed >= 0) {
        return minutes * 60 - countPassed
      } else {
        return 0
      }
      
    },
    timeOver () {
      if (this.calcSecondsPassed(this.recordingInterview.total_limit_time, this.countPassed) === 0) {
        alert("制限時間が終了いたしました。撮影した動画をアップロードします。\nアップロード中はブラウザを閉じないようお願い致します。")
        this.isTimeover = true;
        this.createRecordingAnswer()
      }
    },
    interviewedUserDuplicateCheck () {
      const recordingAnswerInfo = {
        recording_inteview: this.recordingInterview.id,
        email: this.email,
      }
      this.$store.dispatch('directtalk/interviewedUserDuplicateCheck', recordingAnswerInfo)
        .then((d) => {
          if (d.data.is_duplicate_user) {
            alert('この面接は以前受けているため入室することができません。')
            return
          } else {
            this.step = 1
          }
        })
    },
    windowClosePrevent () {
      window.onbeforeunload = function(e) {
        e.returnValue = "";
      }
    },
    cancelWindowClosePrevent () {
      window.onbeforeunload = null;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
html, body, .main-body {
  overflow-y: auto;
  width: 100vw;
  height: 100vh !important;
  max-width: 720px;
  // 画面がちらつくのでスクロールにしてある
  overflow: scroll;
  margin: 0 auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  position: relative;
  .loading {
    position: fixed;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background: white;
    top: 0;
  }
  .company-header{
    background: #f8f8f8;
    height: 72px;
    padding: 4px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
    .left-box {
      width: calc(100% - 96px);
      .-name {
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .-company {
        text-align: left;
        font-size: 13px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .right-box {
      width: 88px;
    }
  }
  .outtime {
    margin: auto;
    margin-top: 40px;
    width: calc(100% - 80px);
    box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
    padding: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    img {
      width: 200px;
    }
    p {
      padding-left: 10px;
      width: calc(100% - 210px);
    }
  }
  .start {
    margin: auto;
    margin-top: 40px;
    width: calc(100% - 80px);
    box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
    padding: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    div {
      width: 100%;
      p {
        margin: 4px;
      }
    }
  }
  .video-container {
    padding: 24px;
    text-align: left;
    position: relative;
    /deep/ .video-back {
      border-radius: 8px;
    }
    .video-wrapper {
      position: relative;
      width: 100%;
      margin-top: 8px;
      margin-bottom: 24px;
      .question-title {
        margin-bottom: 8px;
      }
      .recording-wrapper {
        position: relative;
        .recording-back {
          width: 100%;
          background: #444;
          border-radius: 8px;
          transform: scale(-1, 1);
        }
        .start-button {
          position: absolute;
          top: 0;
          cursor: pointer;
          color: white;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 24px;
          transition: 0.5s;
          p {
            font-size: 18px;
            transition: 0.5s;
          }
          .desc {
            font-size: 13px;
            transition: 0.5s;
          }
        }
        .start-button:hover {
          p {
            font-size: 24px;
          }
          .desc {
            font-size: 16px;
            transition: 0.5s;
          }
        }
      }
    }
    .total-count-icon {
      width: 80px;
      height: 80px;
      position: fixed;
      bottom: 32px;
      right: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: white;
      box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
      border-radius: 100px;
      .count-wrapper {
        text-align: center;
        .nokorijikan {
          font-size: 12px;
        }
        .count {
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
  .loading-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    background: white;
    top: 0;
    left: 0;
    opacity: 0.6;
    display: flex;
    align-items: center;
  }
}
.v-enter-active, .v-leave-active {
  transition: .9s
}
.v-enter, .v-leave {
  transform: translateX(100%);
}
.main-body::-webkit-scrollbar {
  //visibility: hidden;
  //width:  10px;
}
.main-body {
  position: relative;
}

@media screen and (max-width: 500px) {
  /deep/ .start {
    width: calc(100% - 32px) !important;
    padding: 12px;
    font-size: 14px;
    button {
      font-size: 14px;
    }
  }
  /deep/ .outtime {
    width: calc(100% - 32px) !important;
    margin-top: 24px !important;
    padding: 12px;
    font-size: 14px;
    flex-wrap: wrap !important;
    img {
      width: 80% !important;
      margin: auto;
    }
    p {
      width: 100% !important;
      padding: 0;
      margin-top: 8px;
    }
  }
  .video-container {
    button {
      font-size: 12px;
      margin: 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/VideoInterview/RecordInterview.vue